import React from 'react';
const Button = ({
  children,
  type = 'button',
  onClick,
  fullWidth = false,
  variant = 'primary',
  loading = false,
  disabled = false
}) => {
  const baseClasses = 'relative inline-flex justify-center items-center px-6 py-3.5 text-base font-medium rounded-xl transition-all duration-300 focus:outline-none overflow-hidden';
  const variantClasses = {
    primary: 'bg-gradient-to-r from-blue-600 to-sky-600 text-white hover:shadow-lg hover:shadow-blue-500/30 active:from-blue-700 active:to-sky-700',
    outline: 'border-2 border-blue-600 text-blue-700 bg-transparent hover:bg-blue-50 active:bg-blue-100'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const disabledClass = disabled ? 'opacity-60 cursor-not-allowed' : '';
  return <button type={type} onClick={onClick} disabled={disabled || loading} className={`${baseClasses} ${variantClasses[variant]} ${widthClass} ${disabledClass}`} data-id="element-48">
      {loading ? <>
          <span className="inline-flex items-center" data-id="element-49">
            <svg className="animate-spin -ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-50">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-51"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-52"></path>
            </svg>
            Procesando...
          </span>
        </> : <>
          <span className="relative z-10" data-id="element-53">{children}</span>
          {variant === 'primary' && !disabled && <span className="absolute inset-0 bg-white/10 transform -translate-x-full hover:translate-x-0 transition-transform duration-300 ease-in-out" data-id="element-54"></span>}
        </>}
    </button>;
};
export default Button;